import dayjs from 'util/dayjs-init.js';

export const FULL_DATE_TIME_FORMAT = "YYYY/MM/DD HH:mm:ss";
export const DATE_AXIS_TOOLTIP_FORMAT = "YYYY/MM/dd HH:mm:ss";
export const LATEST_UPDATE_FORMAT = "YYYY/MM/DD HH:mm";
export const MONTH_DATE_FORMAT = "YYYY/MM/DD";
export const DATE_TIME_FORMAT = "MM/DD HH:mm";
export const CSV_DATE_TIME_FORMAT = "YYYY-MM-DD-HH-mm-ss"

const BASE_TIME = 60 * 10;

export const isVesselOffline = (navigationData, engineData) => {
  return (
    isPassedBaseTime(navigationData?.vesselLatestGpggaData[0]?.dateTime) &&
    isPassedBaseTime(navigationData?.vesselLatestAisData[0]?.dateTime) &&
    (!engineData ||
      (engineData?.vesselLatestEngineData?.every((v) => isPassedBaseTime(v["dateTime"])) &&
        engineData?.vesselLatestMainEngineData?.every((v) => isPassedBaseTime(v["dateTime"])) &&
        engineData?.vesselLatestGeneratorEngineData?.every((v) =>
          isPassedBaseTime(v["dateTime"])
        ) &&
        engineData?.vesselLatestShaftGeneratorEngineData?.every((v) =>
          isPassedBaseTime(v["dateTime"])
        )))
  );
};

export const isPassedBaseTime = (dateTime) =>
  !dateTime || dayjs.utc(dateTime).add(BASE_TIME, "seconds").isBefore(dayjs.utc());
